export default __webpack_public_path__ + "293dee51dc9db40a49ed5a9d565bbde7.png";